import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "@/lib/api";
import { Loading } from "@/components/common";
import TrialExpired from "@/pages/TrialExpired";

const TrialContext = createContext(null);
export const useTrial = () => useContext(TrialContext);

export default function TrialGate({ children }) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await http.get("/tenant/status");
      setStatus(data);
    } catch {
      setStatus({ status: "active", is_active: true });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loading /></div>;
  if (status?.is_expired) return <TrialExpired status={status} />;

  return <TrialContext.Provider value={{ status, refresh }}>{children}</TrialContext.Provider>;
}
